import { motion } from "framer-motion";
import styled from "styled-components";

export const Figure = styled.figure`
    position: relative;
`;

export const ImageStyled = styled(motion.img)`
    position: absolute;
    left: 0;
`;
